import { isPossiblePhoneNumber, isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';

export function prettyifyPhoneNumber (phoneNumber: string | null) {
    if(phoneNumber) {
        try{
            const phoneNumberToFormat = parsePhoneNumber(phoneNumber, 'US');
            if(phoneNumberToFormat.countryCallingCode === '1') {
                return phoneNumberToFormat.formatNational();
            }
            return phoneNumberToFormat.formatInternational();
        } catch (err) {
            console.error(`Failed to parse phone number: ${phoneNumber}`);
            console.error(err);
            return `Invalid phone number: ${phoneNumber}`;
        }
    } else {
        return 'Not Set';
    }
}

export function prettyifyPhoneNumberWithCountryCode (phoneNumber: string | null) {
    if (phoneNumber) {
        try {
            const phoneNumberToFormat = parsePhoneNumber(phoneNumber, 'US');
            if (phoneNumberToFormat.countryCallingCode === '1' && phoneNumberToFormat.nationalNumber?.length === 10) {
                const digits = phoneNumberToFormat.nationalNumber;
                return `+1 ${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
            }
            return phoneNumberToFormat.formatInternational();
        } catch (err) {
            console.error(`Failed to parse phone number: ${phoneNumber}`);
            console.error(err);
            return `Invalid phone number: ${phoneNumber}`;
        }
    } else {
        return 'Not Set';
    }
}

/* The backend stores phone numbers in a 20-character column, so anything longer fails the
   update even when libphonenumber considers it possible (e.g. a number with a long extension). */
export const MAX_PHONE_NUMBER_LENGTH = 20;

/* Mirrors the backend's phonenumbers.is_possible_number check (a length-based test), which is
   looser than isValidPhoneNumber — a number the backend accepts must not be rejected here.
   Defaults to US but accepts any international number with an explicit country code. */
export function isPossibleUsPhoneNumber (phoneNumber: string) {
    try {
        return phoneNumber.trim().length <= MAX_PHONE_NUMBER_LENGTH && isPossiblePhoneNumber(phoneNumber, 'US');
    } catch (err) {
        console.error(`Failed to validate phone number: ${phoneNumber}`);
        console.error(err);
        return false;
    }
}

export function validatePhoneNumber (phoneNumber: string) {
    try{
        if(phoneNumber === '') {
            return true;
        }
        const parsedPhoneNumber = parsePhoneNumber(phoneNumber, 'US');
        if(parsedPhoneNumber.country) {
            const countryCode = parsedPhoneNumber.country;
            return isValidPhoneNumber(phoneNumber, countryCode);
        } else {
            return isPossiblePhoneNumber(phoneNumber);
        }
    } catch (err) {
        console.error(`Failed to validate phone number: ${phoneNumber}`);
        console.error(err);
    }
}
